<div class="fluid-container col-md-12 col-lg-12  pr-0 entry-class">
    <Span>
        Would you like to select a pre-defined template or create your own Letter to generate Cover Letter?
    </Span>
    <div class="row col-md-12 pl-0 pt-3">
        <!-- <p-radioButton name="coverLetterType" (onClick)="handleSelection(0)" value="0"
            class="letter-radio" label="Select Predefined Template">
        </p-radioButton>
        <p-radioButton name="coverLetterType" (onClick)="handleSelection(1)" value="1" label="Create Own Letter" class="letter-radio">
        </p-radioButton> -->
        <p-radioButton name="coverLetterType" (onClick)="handleSelection()" [value]="0"
            class="letter-radio" label="Select Predefined Template" [(ngModel)]="templateValue">
        </p-radioButton>
        <p-radioButton name="coverLetterType" (onClick)="handleSelection()" [(ngModel)]="templateValue" [value]="1" label="Create Own Letter" class="letter-radio">
        </p-radioButton>
    </div>
</div>
